//
// WARNING
//
// Do not make manual changes to this file.
// This file was generated by scripts/generate-icons.js.
//
// Generated from: chevron-down.svg
//

import React from 'react';
import cs from 'classnames';
export function ChevronDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", {
    className: cs('Icon', 'Icon--chevron-down', props.className),
    style: props.style,
    "aria-hidden": props.title ? undefined : true,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props.title && /*#__PURE__*/React.createElement("title", null, props.title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M53.032 24.865l-19.5 19.5a2.166 2.166 0 01-3.064 0l-19.5-19.5a2.166 2.166 0 113.064-3.064L32 39.77 49.968 21.8a2.167 2.167 0 013.064 3.064z",
    clipRule: "evenodd"
  }));
}